import { render, staticRenderFns } from "./AffirmationEditModal.vue?vue&type=template&id=7453024a"
import script from "./AffirmationEditModal.vue?vue&type=script&lang=js"
export * from "./AffirmationEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports